import { useReducer } from "react";
import axios from "axios";
import { getBasePath } from "../../Helpers/getEnvVar";
import { getAuthToken } from "../../Helpers/localStorage";

const uploadProfileImageHookInitialState = {
  isFetching: false,
  isSuccessful: false,
  errorMessage: "",
  result: {},
};

const uploadProfileImageHookReducer = (state, action) => {
  switch (action.type) {
    case "fetching":
      return {
        ...state,
        isFetching: true,
        isSuccessful: false,
        errorMessage: "",
        result: {},
      };
    case "success":
      return {
        ...state,
        isFetching: false,
        isSuccessful: true,
        result: { ...action.payload },
      };
    case "error":
      return {
        ...state,
        isFetching: false,
        isSuccessful: false,
        errorMessage: action.payload,
      };
    default:
      throw new Error("Unsupported Action");
  }
};

const useUploadProfileImage = () => {
  const [profileImage, dispatch] = useReducer(uploadProfileImageHookReducer, uploadProfileImageHookInitialState);
  const basePath = getBasePath();

  const setUploadProfileImage = ({ userId, image }) => {
    const token = getAuthToken();
    let formData = new FormData();
    formData.append("image", image);
    axios({
      url: `${basePath}/user/${userId}/photo`,
      method: "POST",
      
      data: formData,
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data"
      },
    })
      .then((data) => {
        const logoData = data?.data?.data;
        dispatch({
          type: "success",
          payload: logoData,
        });
      })
      .catch((err) => {
        dispatch({ type: "error", payload: err?.response?.data?.error });
      });
  };

  const uploadProfileImage = (payload) => {
    dispatch({ type: "fetching" });
    setUploadProfileImage(payload);
  };

  return [profileImage, uploadProfileImage];
};

export default useUploadProfileImage;
